interface IH1Heading {
  title: string;
}
export const H1Heading: React.FC<IH1Heading> = ({ title }) => {
  return (
    <h1
      className="text-s-32 font-bold sm:mb-6 mb-2 sm:text-s-24 leading-tight sm:font-bold sm:leading-8"
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
};
